/**
 * P3-24: UpgradeButton —— Workshop 升级按钮。
 *
 * 迁移自 `com.nuclearunicorn.game.ui.UpgradeButtonController` +
 * `BuildingResearchBtn`（js/workshop.js:2789-2879 / core.js:2327-2400）。
 *
 * 行为对齐：
 * - 名称：controller.getName 产出 HTML（已研究时追加 COMPLETE）
 * - 描述：aria-description 取 model.description
 * - 可见：`upgrade.unlocked`；若 `researched && hideResearched` 则隐藏
 * - 禁用：已研究或资源不足
 * - tooltip：`ButtonModernHelper.getTooltipHTML` 直取
 * - 点击：`controller.buyItem(modelRef.current, event)`
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { useUpgradeButtonModel } from "./useWorkshopModel";

interface UpgradeButtonProps {
  upgradeName: string;
}

export function UpgradeButton({ upgradeName }: UpgradeButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useUpgradeButtonModel(upgradeName);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
      getSelectedObject={() => modelRef.current}
    />
  );
}
